import React from 'react';
import { Search } from './components/Search';
import { CreateBtn } from './components/CreateBtn';
import { ChangePositionBtn } from './components/ChangePositionBtn';
import { CustomerSelect } from './components/CustomerSelect';
import { RestaurantSelect } from './components/RestaurantSelect';
import { CategorySelect } from './components/CategorySelect';
import { SubcategorySelect } from './components/SubcategorySelect';
import { ResetBtn } from './components/ResetBtn';
import { SortBy } from './components/SortBy/SortBy';
import { CountOfItem } from './components/CountOfItem';
import { IsDisabledCheckbox } from './components/IsDisabledCheckbox';
import { AssignedCheckbox } from './components/AssignedCheckbox';
import { WithURLFilters } from './components/WithURLFilters';
import style from './DishesControlPanel.module.scss';

export const DishesControlPanel: React.FC = () => {
	return (
		<WithURLFilters>
			<div className={style.firstRowWithControls}>
				<Search />
				<CreateBtn />
				<ChangePositionBtn />
			</div>
			<div className={style.secondRowWithControls}>
				<div className={style.filteringControls}>
					<div className={style.selectWrapper}>
						<CustomerSelect />
						<RestaurantSelect />
						<CategorySelect />
						<SubcategorySelect />
					</div>
					<div className={style.checkBoxesWrapper}>
						<IsDisabledCheckbox />
						<AssignedCheckbox />
					</div>
				</div>
				<div className={style.verticalAlignBlock}>
					<ResetBtn />
					<SortBy />
					<CountOfItem />
				</div>
			</div>
		</WithURLFilters>
	);
};
